<template>
    <div class="p-3">
        <h3>Laporan Retensi dan Pemusnahan</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_dari" class="col-sm-4 col-form-label text-end">Dari</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_dari" id="tanggal_dari" class="form-control" v-model="filter.tanggal_dari">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="tanggal_sampai" class="col-sm-4 col-form-label text-end">Sampai</label>
                    <div class="col-sm-8">
                        <input type="date" name="tanggal_sampai" id="tanggal_sampai" class="form-control" v-model="filter.tanggal_sampai">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getDataLaporan"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Laporan</div>
            <div class="card-body">
                <div id="table-laporan-retensi-dan-pemusnahan"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default {
    data() {
        return {
            per_page: 10,
            filter: {
                tanggal_dari: new Date().toISOString().slice(0, 10),
                tanggal_sampai: new Date().toISOString().slice(0, 10),
            },
            table: null,
        }
    },
    created() {
        this.getDataLaporan()
    },
    methods: {
        resetFilters() {
            this.filter = {
                tanggal_dari: new Date().toISOString().slice(0, 10),
                tanggal_sampai: new Date().toISOString().slice(0, 10),
            }
        },
        getDataLaporan() {
            const uri = `/api/retensi-dan-pemusnahan/get-laporan-retensi-dan-pemusnahan?per_page=${this.per_page}&start_date=${this.filter.tanggal_dari}&end_date=${this.filter.tanggal_sampai}`

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.table = new Tabulator('#table-laporan-retensi-dan-pemusnahan', {
                        data: response.data.master_pasien.data,
                        layout: 'fitColumns',
                        pagination: 'true',
                        paginationMode: 'remote',
                        paginationSize: 10,
                        paginationSizeSelector:[10, 25, 50, 100, true],
                        dataLoader: this.ajaxLoader,
                        ajaxURL: uri,
                        ajaxResponse: this.AjaxResponse,
                        sortMode: 'remote',
                        filterMode: 'remote',
                        columns: [
                            {title: "No. RM", field: "Medrec", sorter: "string"},
                            {title: "Nama", field: "Firstname", sorter: "string"},
                            {title: "NIK", field: "NoIden", sorter: "string"},
                            {title: "No. Kartu BPJS", field: "AskesNo", sorter: "string"},
                            {title: "Jenis Kelamin", field: "Sex", sorter: "string"},
                            {title: "Tanggal Lahir", field: "Bod", sorter: "string"},
                            {title: "Tanggal Daftar", field: "tgl_daftar", sorter: "string"},
                            {title: "Tanggal Pemusnahan", field: "tanggal_retensi_dan_pemusnahan", sorter: "string"},
                            {title: 'Dokumen', formatter: function (cell, formatterParams) {
                                return '<button class="btn btn-sm btn-primary" id="detail">Detail</button>'
                            }, cellClick: this.rowActions},
                        ]
                    })
                }
            })
        },
        ajaxLoader() {
            // set loading screen
        },
        AjaxResponse(url, params, response) {
            return response[0].master_pasiens
        },
        rowActions(e, cell) {
            const data = cell.getRow().getData()
            const medrec = data.Medrec

            this.$router.push({
                name: 'pasien_tidak_aktif_5_tahun_details',
                params: { Medrec: medrec}
            })
        }
    }
}
</script>